import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card, Nav, Alert, Spinner, Badge } from 'react-bootstrap';
import { FaExclamation, FaExclamationCircle, FaExclamationTriangle, FaStopCircle } from 'react-icons/fa';
import Select from 'react-select';

const ModalConducteur = ({ show, onHide, onSave, typeParc, parcRef, camion }) => {

    const user_id = localStorage.getItem("userId");



    // États pour la gestion des erreurs et vérifications
    const [erreurConducteurs, setErreurConducteurs] = useState("");
    const [erreurConfirmation, setErreurConfirmation] = useState("");
    const [verificationConducteurEnCours, setVerificationConducteurEnCours] = useState(false);
    const [miseEnFilerEnCours, setMiseEnFilerEnCours] = useState(false);

    // États pour stocker les informations vérifiées
    const [infosConducteurPrincipal, setInfosConducteurPrincipal] = useState(null);
    const [infosConducteurAssistant, setInfosConducteurAssistant] = useState(null);

    // États pour contrôler la visibilité des boutons
    const [conducteursVerifies, setConducteursVerifies] = useState(false);
    const [boutonSuivantVisible, setBoutonSuivantVisible] = useState(false);
    const [boutonSuivantConducteurVisible, setBoutonSuivantConducteurVisible] = useState(false);
    const [boutonEnregistrerVisible, setBoutonEnregistrerVisible] = useState(false);


    const resetForm = () => {
        const parcReference = formData.reference_parc;
        setFormData({
            nom_conducteur_principal: '',
            numero_permis_principal: '',
            telephone_principal: '',
            telephone_assistant: '',
            categorie_permis_principal: '',
            date_naissance_principal: '',
            nom_conducteur_assistant: '',
            numero_permis_assistant: '',
            categorie_permis_assistant: '',
            date_naissance_assistant: '',

            motif_remplacement: ''
        });

        // setInfosCamion1(null);
        // setInfosCamion2(null);
        setInfosConducteurPrincipal(null);
        setInfosConducteurAssistant(null);
        setConducteursVerifies(false);
        // setBoutonSuivantVisible(false);
        // setBoutonSuivantConducteurVisible(false);
        // setBoutonEnregistrerVisible(false);
        // setSelectedParc(null);
        // setSelectedCategories(null);
        // setErreurCarte("");
        setErreurConducteurs("");
        setErreurConfirmation("");
    };

    useEffect(() => {
        if (show) {
            resetForm();
        }
    }, [show]);


    // Fonction pour vérifier les conducteurs via l'API backend
    const verifierConducteurs = async () => {
        setVerificationConducteurEnCours(true);
        setErreurConducteurs("");
        setInfosConducteurPrincipal(null);
        setInfosConducteurAssistant(null);
        setConducteursVerifies(false);

        const c1 = formData.numero_permis_principal;
        const c2 = formData.numero_permis_assistant;
        const numero_identite = formData.numero_identite;

        try {
            if (!c1) {
                setErreurConducteurs("Le numéro de permis du conducteur principal est obligatoire.");
                setVerificationConducteurEnCours(false);
                return;
            }

            // Vérification que l'assistant a au moins une donnée
            // if (!c2 && !numero_identite) {
            //     setErreurConducteurs("L'assistant est obligatoire. Veuillez renseigner soit son numéro de permis, soit son numéro d'identification.");
            //     setVerificationConducteurEnCours(false);
            //     return;
            // }

            // Récupérer le token d'authentification
            const token = localStorage.getItem('access_token');

            // Vérification du conducteur principal
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    numero_permis: c1,
                    user_id: user_id,
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                setErreurConducteurs(errorData.message || "Erreur lors de la vérification du conducteur principal.");
                setVerificationConducteurEnCours(false);
                return;
            }

            const conducteurPrincipalValide = await response.json();
            setInfosConducteurPrincipal(conducteurPrincipalValide.data);

            // Récupérer le téléphone du conducteur principal
            setFormData(prev => ({
                ...prev,
                telephone_principal: conducteurPrincipalValide.data.phone || ''
            }));

            // Vérification du conducteur assistant
            if (c2) {
                if (c1 === c2) {
                    setErreurConducteurs("Les numéros de permis des deux conducteurs doivent être différents.");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const response2 = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        numero_permis: c2,
                        user_id: user_id,
                    })
                });

                if (!response2.ok) {
                    const errorData = await response2.json();
                    setErreurConducteurs(errorData.message || "Erreur lors de la vérification du conducteur assistant..");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const conducteurAssistantValide = await response2.json();
                setInfosConducteurAssistant(conducteurAssistantValide.data);

                // Récupérer le téléphone du conducteur assistant
                setFormData(prev => ({
                    ...prev,
                    telephone_assistant: conducteurAssistantValide.data.phone || ''
                }));

            } else if (numero_identite) {
                // Vérification via numéro d'identité
                const response3 = await fetch(`${process.env.REACT_APP_HOTE}/api/verifier-conducteur/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        numero_identite: numero_identite
                    })
                });

                if (!response3.ok) {
                    const errorData = await response3.json();
                    setErreurConducteurs(errorData.error || "Erreur lors de la vérification via numéro d'identité.");
                    setVerificationConducteurEnCours(false);
                    return;
                }

                const conducteurIdentiteValide = await response3.json();
                setInfosConducteurAssistant(conducteurIdentiteValide.data);

                // Récupérer le téléphone du conducteur assistant
                setFormData(prev => ({
                    ...prev,
                    telephone_assistant: conducteurIdentiteValide.data.phone || ''
                }));
            }

            // Vérifier que les deux conducteurs sont bien vérifiés avant d'afficher le bouton suivant
            if (infosConducteurPrincipal) {
                setBoutonSuivantConducteurVisible(true);
            }

            setVerificationConducteurEnCours(false);
            setConducteursVerifies(true);

        } catch (error) {
            console.error("Erreur lors de la vérification:", error);
            setErreurConducteurs("Une erreur réseau s'est produite. Veuillez réessayer.");
            setVerificationConducteurEnCours(false);
            setConducteursVerifies(false);
        }
    };

    useEffect(() => {
        // Vérifier automatiquement quand les deux conducteurs sont disponibles
        if (infosConducteurPrincipal) {
            setBoutonSuivantConducteurVisible(true);
            setErreurConducteurs("");
        } else {
            setBoutonSuivantConducteurVisible(false);
        }
    }, [infosConducteurPrincipal]);


    const validerConfirmation = () => {
        if (!formData.numero_permis_principal) {
            setErreurConfirmation("Le numéro de permis du conducteur principal est obligatoire.");
            return false;
        }

        setErreurConfirmation("");
        setBoutonEnregistrerVisible(true);
        return true;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validerConfirmation()) {
            setMiseEnFilerEnCours(true);
            setConducteursVerifies(true);

            try {
                const donneesCompletes = {
                    ...formData,
                    tour_id: camion?.id,
                    // conducteur_principal: infosConducteurPrincipal,
                    // conducteur_assistant: infosConducteurAssistant,

                    conducteur_principal: {
                        nom_conducteur: infosConducteurPrincipal.nom,
                        numero_permis: infosConducteurPrincipal.numero_permis,
                        categorie_permis: infosConducteurPrincipal.categorie_permis,
                        telephone: infosConducteurPrincipal.phone,
                        date_naissance: infosConducteurPrincipal.date_naissance,
                        date_validite: infosConducteurPrincipal.date_validite,
                        nationalite: infosConducteurPrincipal.nationalite,
                    },

                    conducteur_assistant: infosConducteurAssistant
                        ? {
                            nom_conducteur: infosConducteurAssistant.nom,
                            numero_permis: infosConducteurAssistant.numero_permis,
                            categorie_permis: infosConducteurAssistant.categorie_permis,
                            telephone: infosConducteurAssistant.phone,
                            date_naissance: infosConducteurAssistant.date_naissance,
                            date_validite: infosConducteurAssistant.date_validite,
                            nationalite: infosConducteurAssistant.nationalite,
                            numero_identite: infosConducteurAssistant.numero_identite
                        }
                        : null,

                    user_id,
                    timestamp: new Date().toISOString()
                };


                // Appeler onSave et attendre le résultat
                const result = await onSave(donneesCompletes);

                // Vider le formulaire seulement si l'envoi est réussi
                resetForm();

            } catch (error) {
                console.error("❌ Erreur lors de la mise en file :", error);
            } finally {
                setMiseEnFilerEnCours(false);
            }
        }
    };


    // États initiaux du formulaire
    const [formData, setFormData] = useState({

        nom_conducteur_principal: '',
        numero_permis_principal: '',
        categorie_permis_principal: '',
        date_naissance_principal: '',
        nom_conducteur_assistant: '',
        numero_permis_assistant: '',
        numero_identite: '',
        categorie_permis_assistant: '',
        date_naissance_assistant: '',
        motif_remplacement: ''
    });


    const handleChange = (e) => {
        const { name, value } = e.target;

        // Champs qui doivent être en majuscules
        const uppercaseFields = ["reference_carte_transport_1", "reference_carte_transport_2"];

        setFormData((prev) => ({
            ...prev,
            [name]: uppercaseFields.includes(name) ? value.toUpperCase() : value,
        }));
    };


    // Rendu de l'onglet Conducteur
    const renderConducteurTab = () => (
        <>
            {/* Bloc Conducteur Principal */}
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">Conducteur principal <span style={{ color: 'red' }}>*</span></h6>
                </Card.Header>

                {erreurConducteurs && (
                    <Alert variant="danger" className="m-3 mb-0 py-1">
                        {erreurConducteurs}
                    </Alert>
                )}
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro du permis du conducteur principal</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_permis_principal"
                                    value={formData.numero_permis_principal}
                                    onChange={handleChange}
                                    required
                                    placeholder="Numéro de permis"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Affichage des informations du conducteur principal */}
                    {infosConducteurPrincipal && (
                        <Card className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Informations du conducteur principal</h6>
                                {/* <Badge bg="info">Vérifié</Badge> */}
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Nom :</strong> {infosConducteurPrincipal.nom}</p>
                                        <p><strong>Catégorie permis :</strong> {infosConducteurPrincipal.categorie_permis}</p>
                                        <p><strong>Téléphone :</strong> {infosConducteurPrincipal.phone || 'Non renseigné'}</p>
                                        {/* <p><strong>Date de naissance :</strong> {infosConducteurPrincipal.date_naissance}</p> */}
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Statut :</strong> {infosConducteurPrincipal.statut}</p>
                                        <p><strong>Date d'expiration :</strong> {new Date(infosConducteurPrincipal.date_validite).toLocaleDateString()}</p>
                                        {infosConducteurPrincipal.nationalite && (
                                            <p><strong>Nationalité:</strong> {infosConducteurPrincipal.nationalite}</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Card.Body>
            </Card>

            {/* Bloc Conducteur Assistant */}
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">Conducteur assistant</h6>
                </Card.Header>
                <Card.Body>
                    {/* <Alert variant="info" className="mb-3">
                        <strong>Information :</strong> Vous devez renseigner au moins une des deux informations suivantes pour l'assistant.
                    </Alert> */}

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro du permis du conducteur assistant</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_permis_assistant"
                                    value={formData.numero_permis_assistant}
                                    onChange={handleChange}
                                    placeholder="Numéro du permis du conducteur l'assistant"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro de la pièce d'identité de l'assistant</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numero_identite"
                                    value={formData.numero_identite}
                                    onChange={handleChange}
                                    placeholder="Numéro de la pièce d'identité"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Affichage des informations du conducteur assistant */}
                    {infosConducteurAssistant && (
                        <Card className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Informations de l'assistant</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Nom :</strong> {infosConducteurAssistant.nom}</p>
                                        <p><strong>Catégorie permis :</strong> {infosConducteurAssistant.categorie_permis}</p>
                                        <p><strong>Téléphone :</strong> {infosConducteurAssistant.phone || 'Non renseigné'}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Statut :</strong> {infosConducteurAssistant.statut}</p>
                                        <p><strong>Date d'expiration :</strong> {new Date(infosConducteurAssistant.date_validite).toLocaleDateString()}</p>
                                        {infosConducteurAssistant.nationalite && (
                                            <p><strong>Nationalité :</strong> {infosConducteurAssistant.nationalite}</p>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Card.Body>
            </Card>

            {/* Motif de remplacement */}
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">
                        Motif du remplacement
                    </h6>
                </Card.Header>

                <Card.Body>
                    <Form.Group>
                        <Form.Label>Veuillez préciser la raison du remplacement</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="motif_remplacement"
                            value={formData.motif_remplacement}
                            onChange={handleChange}
                            placeholder="Ex : Chauffeur indisponible, problème administratif, remplacement urgent..."
                        // required
                        />
                    </Form.Group>
                </Card.Body>
            </Card>
        </>
    );

    const getImmatriculation = () => {
        if (!camion) return "N/A";

        if (camion.atellage === "1") {
            return `${camion?.tete || ""} + ${camion?.queue || ""}`;
        }

        return camion?.immatriculation || "N/A";
    };


    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Camion sélectionné : {getImmatriculation()} du Tour N° {camion?.ordre} </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {renderConducteurTab()}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            <div className="d-flex align-items-center">
                                <Button
                                    variant="outline-primary"
                                    onClick={verifierConducteurs}
                                    disabled={verificationConducteurEnCours}
                                    className="mr-2"
                                >
                                    {verificationConducteurEnCours ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Vérification...
                                        </>
                                    ) : (
                                        "Vérifier les conducteurs"
                                    )}
                                </Button>
                                <Button variant="success" type="submit" disabled={miseEnFilerEnCours || !conducteursVerifies}>
                                    {miseEnFilerEnCours ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> Chargement...
                                        </>
                                    ) : (
                                        "Remplacer"
                                    )}
                                </Button>

                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalConducteur;